module.exports = __webpack_public_path__ + "static/media/170.546a12b3.jpg";